import { render, staticRenderFns } from "./Coupon_records.vue?vue&type=template&id=f637e8a2&scoped=true&"
import script from "./Coupon_records.vue?vue&type=script&lang=js&"
export * from "./Coupon_records.vue?vue&type=script&lang=js&"
import style0 from "./Coupon_records.vue?vue&type=style&index=0&id=f637e8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f637e8a2",
  null
  
)

export default component.exports